<template>
<div>
  <div class="table-wrap">
    <el-table
      :data="pageData.list"
      style="width: 100%">
      <el-table-column
        prop="task_id"
        label="TASKID"
        width="250">
      </el-table-column>
      <el-table-column
        prop="name"
        label="流程名称"
        width="250">
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        width="250">
        <template slot-scope="scope">
          <template v-if="scope.row.create_time">
            {{  scope.row.create_time }}
          </template>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="250">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="navTo(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="delRevocation(scope.row.task_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>

  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
  </div>

</div>
</template>

<script>
import Http from "../common/Http";

export default {
  name: "Revocation",
  props:{
    where:{
      type:Object,
      default(){
        return {};
      }
    }
  },
  data(){
    return{
      $_where:{},
      loading:true,
      pageData:{
        list:[],
        total:0,
        pageSize:15,
        page:1
      },
    }
  },
  activated() {
    this.getList()
  },
  methods:{
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      const that = this;
      that.loading=true;
      let where=JSON.parse(JSON.stringify(that.where));
      Http.get("flow/FlowForm/getRevocationList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    delRevocation(taskId) {
      let that = this;
      that.loading=true;
      this.$confirm('是否要删除审批单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Http.get("flow/FlowForm/delRevocation",{
          task_id:taskId,
        },res=>{
          if(res.code) {
            that.getList();
          } else {
            this.$message.error(res.msg)
          }
          that.loading=false;
        })
      }).catch(() => {
        that.loading=false;
      });
    },
    navTo(item){
      // this.$router.push({path:"/flow/FlowView",query:{sheet_id:item.sheet_id,master_id:item.master_id,task_id:item.task_id,timeValue:Date.now()}});
      this.$router.push({path:"/flow/FlowView",query:{sheet_id:item.sheet_id,master_id:item.master_id,task_id:item.task_id}});
    },
  },
  watch:{
    where:{
      deep:true,
      immediate:true,
      handler(n){
        n&&this.getList();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/Revocation.vue